module.exports = __webpack_public_path__ + "static/media/uy-flag.72a87ef1.svg";